import React from "react";
interface props {
  className?: string;
}

function MapPinContactUs({ className }: props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      className={className}
      fill="none"
      viewBox="0 0 36 36"
    >
      <circle cx="18" cy="18" r="18" fill="#FEECE6"></circle>
      <path
        fill="#262626"
        d="M17.999 11.54a5.083 5.083 0 00-5.077 5.076c0 4.344 4.615 7.625 4.812 7.762a.462.462 0 00.53 0c.196-.137 4.812-3.418 4.812-7.762a5.083 5.083 0 00-5.077-5.077zm0 3.23a1.846 1.846 0 110 3.692 1.846 1.846 0 010-3.692z"
      ></path>
    </svg>
  );
}

export default MapPinContactUs;
